import { render, staticRenderFns } from "./UploadFileDrawingBoard.vue?vue&type=template&id=7aa7de58&scoped=true"
import script from "./UploadFileDrawingBoard.vue?vue&type=script&lang=js"
export * from "./UploadFileDrawingBoard.vue?vue&type=script&lang=js"
import style0 from "./UploadFileDrawingBoard.vue?vue&type=style&index=0&id=7aa7de58&lang=css"
import style1 from "./UploadFileDrawingBoard.vue?vue&type=style&index=1&id=7aa7de58&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa7de58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aa7de58')) {
      api.createRecord('7aa7de58', component.options)
    } else {
      api.reload('7aa7de58', component.options)
    }
    module.hot.accept("./UploadFileDrawingBoard.vue?vue&type=template&id=7aa7de58&scoped=true", function () {
      api.rerender('7aa7de58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Upload/UploadFileDrawingBoard.vue"
export default component.exports